import { useMutation } from "@apollo/client";
import type {
  Project,
  UpdateProjectInput,
  UpdateProjectPayload,
  ProjectPatch,
} from "@casey/db-types";
import { UPDATE_PROJECT } from "../gql";

interface ProjectContextUpdate {
  special_instructions?: string;
}

interface UpdateProjectContextInput {
  projectId: string;
  context: ProjectContextUpdate;
}

interface UpdateProjectContextVariables {
  input: UpdateProjectInput;
}

interface UpdateProjectContextResponse {
  updateProject: UpdateProjectPayload;
}

export function useUpdateProjectContext() {
  const [updateProjectMutation, { data, loading, error }] = useMutation<
    UpdateProjectContextResponse,
    UpdateProjectContextVariables
  >(UPDATE_PROJECT, {
    errorPolicy: "all",
  });

  const updateProjectContext = async (
    input: UpdateProjectContextInput,
  ): Promise<Project | null> => {
    try {
      const projectPatch: ProjectPatch = {
        context: JSON.stringify(input.context),
      };

      const result = await updateProjectMutation({
        variables: {
          input: {
            id: input.projectId,
            patch: projectPatch,
          },
        },
      });

      const updatedProject = result.data?.updateProject?.project;
      return updatedProject || null;
    } catch (err) {
      console.error("Error updating project context:", err);
      throw err;
    }
  };

  return {
    updateProjectContext,
    data: data?.updateProject?.project,
    loading,
    error,
  };
}

export type { UpdateProjectContextInput, ProjectContextUpdate };
